import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

const API = process.env.REACT_APP_API;

const PageBackground = () => {
  const [backgroundUrl, setBackgroundUrl] = useState("");
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname === "/" ? "" : location.pathname.split("/")[1];   // דף ברירת מחדל

    if (!path) return setBackgroundUrl("");     // אל תציג רקע בעמוד הראשי

    axios.get(`${API}/api/backgrounds/${path}`)
      .then(res => {
        if (res.data && res.data.length > 0) {
          const latestImage = res.data[res.data.length - 1];
          setBackgroundUrl(latestImage.url);
        } else {
            setBackgroundUrl(""); // אין תמונה
        }
      })
      .catch(err => {
        console.error("שגיאה בטעינת תמונת רקע:", err);
      });
  }, [location.pathname]);

  if (!backgroundUrl) return null;

  return (
    <div
      style={{
        backgroundImage: `url(${backgroundUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "fixed",
        width: "100%",
        height: "100%",
        zIndex: 0,
        opacity: 0.10,
        transition: "background-image 0.5s ease-in-out",
        pointerEvents: "none",
      }}
    />
  );
};

export default PageBackground;
